export function renderLabelName(param) {
    let label;
    const {provider, metadata} = param
    if(provider == "autodesk") label = metadata.given_name
    if(provider == "googledrive") label = metadata.name
    if(provider == "redas") label = metadata.name
    if(provider == "sgbuildex") label = metadata?.data?.identity?.name
    if(provider == "excel") label = param.label
    if(provider == "ets") label = param.label
    if(provider == "Concrete Cube Test") label = param.label
    return label
}